export interface LapsedTransactionUpdatePayload {
  form17Comment: string | null;
  costElementTransactions: {
    id?: string;
    amount: number;
    costElementId: number;
  }[];
}
